<div class="grid">
    <ng-container *ngrxLet="{ restrictionsList: restrictionsList$ } as vm">
        <dss-shared-lib-applications-list-filters
            *ngrxLet="listFiltersCapabilities$ as listFiltersCapabilities"
            [initialFilters]="initialFilters"
            [flightZonePurposes]="listFiltersCapabilities?.flightZonePurposes"
            [institutions]="institutionsFilterOptions$ | ngrxPush"
            [hasSupervisorPermissions]="hasSupervisorPermissions$ | ngrxPush"
            shouldDisableSendDateFilter
            [searchInputPlaceholder]="'dssAdminLibFlightZoneManagement.restrictionsList.searchFilterLabel' | transloco"
            (filtersChange)="applyFilters($event)"
            (institutionSearchTextChange)="findInstitutionByText($event)"
            (filtersListsClear)="clearFilterLists()"
        >
            <ng-container totalCount>
                {{
                    "dssAdminLibFlightZoneManagement.applicationListShared.totalRestrictionsCountLabel"
                        | transloco : { totalCount: vm.restrictionsList?.page?.totalElements ?? 0 }
                }}
            </ng-container>
        </dss-shared-lib-applications-list-filters>

        <dss-admin-lib-restrictions-table
            [displayedColumns]="displayedColumns"
            [restrictions]="vm.restrictionsList?.content"
            [page]="vm.restrictionsList?.page"
            [isProcessing]="isProcessing$ | ngrxPush"
            [hasDataRetrievalError]="hasListDataRetrievalError$ | ngrxPush"
            (pageChange)="changePage($event)"
            (listRefresh)="refreshList()"
            (kmlDownload)="downloadKml($event)"
        ></dss-admin-lib-restrictions-table>
    </ng-container>
</div>
